















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import VarietyListApi from '@/app/model/api/varietyListApi'
import VarietyDetailApi from '@/app/model/api/varietyDetailApi'
import AreaListApi from '@/app/model/api/areaListApi'
import VarietyGrowthDetailApi from '@/app/model/api/varietyGrowthDetailApi'
import VarietyGrowthCreateApi from '@/app/model/api/varietyGrowthCreateApi'
import VarietyGrowthEditApi from '@/app/model/api/varietyGrowthEditApi'
import VarietyGrowthDeleteApi from '@/app/model/api/varietyGrowthDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Error409Modal,
    Loading,
    ConfirmModal,
    ErrorInfo
  }
})
export default class GroupCreate extends Vue {
  private intermittentWaterPeriodFlags: any = []
  private checkList: any = []
  private beforeCheckList: any = []
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private varietyData: any = []
  private areaData: any = []
  private constantValue: any = []
  private isError: any = {}
  private isDisable: any = {}
  private varietyDetail: any = []
  private varietyGrowthData: any = {
    variety_growth: {
      variety_growth_name: '',
      variety_id: '',
      area_id: '',
      cultivation_method_id: 1,
      harvest_correction_minus: 3,
      harvest_correction_plus: 3,
      season_id: 1,
      remarks: '',
      completion_status: 2,
      variety_growth_checklist: []
    },
    variety_growth_stages: [
      {
        step: 1,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE1,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE1),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE1),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE1)
      },
      {
        step: 3,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE3,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE3),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE3),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE3)
      },
      {
        step: 4,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE4,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE4),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE4),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE4)
      },
      {
        step: 5,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE5,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE5),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE5),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE5)
      },
      {
        step: 6,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE6,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE6),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE6),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE6)
      },
      {
        step: 7,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE7,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE7),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE7),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE7)
      },
      {
        step: 8,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE8,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE8),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE8),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE8)
      },
      {
        step: 9,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE9,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE9),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE9),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE9)
      },
      {
        step: 10,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: '',
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE10),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE10),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE10)
      },
      {
        step: 11,
        integrated_temp: 0,
        element1: 0,
        element2: 0,
        element3: 0,
        element4: 0,
        soil_ec: 0,
        ground_temp: 0,
        watering_name: process.env.VUE_APP_WATERINGNAME_STAGE11,
        water_contain_rate: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE11),
        watering_days: Number(process.env.VUE_APP_WATERINGDAYS_STAGE11),
        watering_cut_flag: 1,
        water_contain_rate_min: Number(process.env.VUE_APP_WATER_CONTAIN_RATE_MIN_STAGE11)
      }
    ]
  }
  private completionStatus: any = [
    { text: '完成版', value: 1 },
    { text: '暫定版', value: 2 },
    { text: '情報未入手', value: 3 }
  ]
  private masterKeys: any = [
    {
      keyName: 'soil_ec',
      parameta: '土壌EC',
      errorName: 'soilEcErrorMessage'
    },
    {
      keyName: 'ground_temp',
      parameta: '地温',
      errorName: 'groundTempErrorMessage'
    }
  ]
  private elementKeys: any = [
    {
      keyName: 'element1',
      parameta: process.env.VUE_APP_ELEMENT1_NAME,
      errorName: 'element1ErrorMessage'
    },
    {
      keyName: 'element2',
      parameta: process.env.VUE_APP_ELEMENT2_NAME,
      errorName: 'element2ErrorMessage'
    },
    {
      keyName: 'element3',
      parameta: process.env.VUE_APP_ELEMENT3_NAME,
      errorName: 'element3ErrorMessage'
    },
    {
      keyName: 'element4',
      parameta: process.env.VUE_APP_ELEMENT4_NAME,
      errorName: 'element4ErrorMessage'
    }
  ]
  private waterControlNames: any = [process.env.VUE_APP_WATERINGNAME_STAGE1, process.env.VUE_APP_WATERINGNAME_STAGE3, process.env.VUE_APP_WATERINGNAME_STAGE4, process.env.VUE_APP_WATERINGNAME_STAGE5, process.env.VUE_APP_WATERINGNAME_STAGE6, process.env.VUE_APP_WATERINGNAME_STAGE7, process.env.VUE_APP_WATERINGNAME_STAGE8, process.env.VUE_APP_WATERINGNAME_STAGE9, process.env.VUE_APP_WATERINGNAME_STAGE10, process.env.VUE_APP_WATERINGNAME_STAGE11]
  private waterLevels: any = [Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE1), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE3), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE4), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE5), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE6), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE7), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE8), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE9), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE10), Number(process.env.VUE_APP_WATER_CONTAIN_RATE_STAGE11)]
  private waterControlDays: any = [Number(process.env.VUE_APP_WATERINGDAYS_STAGE1), Number(process.env.VUE_APP_WATERINGDAYS_STAGE3), Number(process.env.VUE_APP_WATERINGDAYS_STAGE4), Number(process.env.VUE_APP_WATERINGDAYS_STAGE5), Number(process.env.VUE_APP_WATERINGDAYS_STAGE6), Number(process.env.VUE_APP_WATERINGDAYS_STAGE7), Number(process.env.VUE_APP_WATERINGDAYS_STAGE8), Number(process.env.VUE_APP_WATERINGDAYS_STAGE9), Number(process.env.VUE_APP_WATERINGDAYS_STAGE10), Number(process.env.VUE_APP_WATERINGDAYS_STAGE11)]
  private saveConfirmMessage: string = '<p>コピーまたは実績からの新規作成の場合は<br>すべての内容を確認してください。<br/>この内容で保存してもよろしいでしょうか？</p>'
  private changeConfirmMessage: string = '<p>品種を変更すると、利用しないステージの内容は破棄されます。<br/>よろしいですか？</p>'
  /* 表示非表示 */
  private isEdit: boolean = false
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private notSelectVariety: boolean = true
  private showError409Modal: boolean = false
  private showChangeVerifyModal: boolean = false
  private copyFlag: boolean = false
  private isCopy: boolean = false
  private show400ErrorMessage: boolean = false
  private showSaveConfirmModal: boolean = false

  private get route (): any {
    return this.$route.path
  }
  @Watch('route')
  getRoute (route: string) {
    if (this.copyFlag && route === '/master/variety-growth/create') {
      location.reload()
    }
  }

  created () {
    this.getVarietyList()
    this.getAreaList()
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.$route.path === '/master/variety-growth/create') {
      // コピーがあれば表示、なければデフォルト表示
      const copyData = JSON.parse(Session.getCopyVarietyGrowthData()!)
      if (copyData === undefined || copyData === null) {
        // チェックリストに選択状態項目追加
        for (let i in this.constantValue.checklist_tasks) {
          this.constantValue.checklist_tasks[i].check_status = false
        }

        // stage_stepが7,8,10は初期checkあり
        this.intermittentWaterPeriodFlags = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11]
      } else {
        this.isCopy = true
        this.varietyGrowthData = copyData
        sessionStorage.removeItem('varietyGrowthCopyData')
        this.notSelectVariety = false
        // チェックリストに選択状態項目追加
        for (let i in this.constantValue.checklist_tasks) {
          this.constantValue.checklist_tasks[i].check_status = false
        }
        this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)
        // 品種生育名に（コピー）と表示
        this.varietyGrowthData.variety_growth.variety_growth_name = this.varietyGrowthData.variety_growth.variety_growth_name + '（コピー）'
        // 間断潅水flag設定
        for (let i in this.varietyGrowthData.variety_growth_stages) {
          if (this.varietyGrowthData.variety_growth_stages[i].watering_cut_flag === 1) {
            this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
          }
        }
      }
      this.isEdit = false
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getVarietyGrowthDetail()
    }
  }

  private getVarietyName (id: any) {
    for (let i in this.varietyData) {
      if (this.varietyData[i].variety_id === id) {
        return this.varietyData[i].variety_name
      }
    }
  }

  private dateToStringYmdHm (date: any) {
    if (date !== undefined && date !== null) {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    } else {
      return '-'
    }
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string, key3: string) {
    let before
    if (key1 === 'variety_growth') {
      before = String(this.varietyGrowthData[key1][key3])
    } else {
      before = String(this.varietyGrowthData[key1][key2][key3])
    }

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    if (key1 === 'variety_growth') {
      if (isNaN(parseFloat(after))) {
        this.varietyGrowthData[key1][key3] = null
      } else {
        this.varietyGrowthData[key1][key3] = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.varietyGrowthData[key1][key2][key3] = null
      } else {
        this.varietyGrowthData[key1][key2][key3] = parseFloat(after)
      }
    }
  }

  private beforeVarietyId: number = 0

  // 品種が変更される場合は変更確認モーダルを表示
  private changeVariety () {
    if (this.notSelectVariety) {
      this.beforeVarietyId = this.varietyGrowthData.variety_growth.variety_id
      this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)
    } else {
      this.showChangeVerifyModal = true
    }
  }

  // 変更前の品種を保持
  private beforeChangeVariety () {
    this.beforeVarietyId = this.varietyGrowthData.variety_growth.variety_id
  }

  // 変更前の品種に戻す
  private changeVarietyCancel () {
    this.showChangeVerifyModal = false
    this.varietyGrowthData.variety_growth.variety_id = this.beforeVarietyId
  }

  // 品種情報取得
  private getVarietyList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'variety_name',
        sort: true
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから圃場を追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // 地域情報取得
  private getAreaList () {
    (async () => {
      const data = {
        text: '',
        sortName: 'area_name',
        sort: 'asc'
      }

      const result = await AreaListApi.getAreaList(data)

      if (result.isOk()) {
        this.areaData = result.getPayload().areas
        if (result.getPayload().total_area === 0) {
          this.alertTitle = '地域が未登録です。地域を登録してから圃場を追加してください。'
          this.alertText = ''
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private getVarietyDetail (id: string) {
    (async () => {
      this.showChangeVerifyModal = false
      this.notSelectVariety = false
      this.resetError()
      const result = await VarietyDetailApi.getVarietyDetail(id)
      if (result.isOk()) {
        this.varietyDetail = result.getPayload().variety_stages
        // ステージ利用flag設定
        for (let i in this.varietyDetail) {
          if (this.varietyDetail[i].is_valid === 1) {
            this.$set(this.isDisable, 'is_valid' + this.varietyDetail[i].step, false)
            this.varietyGrowthData.variety_growth_stages[i].is_valid = 1

            if (!this.isEdit && !this.isCopy) {
              if (this.varietyGrowthData.variety_growth_stages[i].watering_name === '') {
                this.varietyGrowthData.variety_growth_stages[i].watering_name = this.waterControlNames[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].water_contain_rate === 0) {
                this.varietyGrowthData.variety_growth_stages[i].water_contain_rate = this.waterLevels[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].watering_days === 0) {
                this.varietyGrowthData.variety_growth_stages[i].watering_days = this.waterControlDays[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].step !== 10) {
                this.varietyGrowthData.variety_growth_stages[i].watering_cut_flag = 1
                if (this.intermittentWaterPeriodFlags.indexOf(this.varietyGrowthData.variety_growth_stages[i].step) === -1) {
                  this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
                }
              }
            }
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyDetail[i].step, true)
            this.varietyGrowthData.variety_growth_stages[i] = {
              step: this.varietyDetail[i].step,
              integrated_temp: 0,
              element1: 0,
              element2: 0,
              element3: 0,
              element4: 0,
              soil_ec: 0,
              ground_temp: 0,
              watering_name: '',
              water_contain_rate: 0,
              watering_days: 0,
              watering_cut_flag: 0,
              water_contain_rate_min: 0,
              is_valid: 0
            }
            let num = this.intermittentWaterPeriodFlags.indexOf(this.varietyDetail[i].step)
            if (num !== -1) {
              this.intermittentWaterPeriodFlags.splice(num, 1)
            }
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.isCopy = false
      this.showLoading = false
    })()
  }

  private doSave () {
    // 間断潅水flag設定
    for (let i in this.varietyGrowthData.variety_growth_stages) {
      if (this.intermittentWaterPeriodFlags.includes(this.varietyGrowthData.variety_growth_stages[i].step)) {
        this.varietyGrowthData.variety_growth_stages[i].watering_cut_flag = 1
      } else {
        this.varietyGrowthData.variety_growth_stages[i].watering_cut_flag = 0
      }
    }

    /* バリデーションチェック */
    if (!this.doValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    const data: any = {
      variety_growth: this.varietyGrowthData.variety_growth,
      variety_growth_stages: []
    }

    // 利用するステージのみをリクエストする
    for (let j in this.varietyGrowthData.variety_growth_stages) {
      if (this.varietyGrowthData.variety_growth_stages[j].is_valid === 1) {
        data.variety_growth_stages.push(this.varietyGrowthData.variety_growth_stages[j])
      }
    }

    if (this.isEdit) {
      // チェックリストに更新があるか判定
      let status = []
      for (let i in this.constantValue.checklist_tasks) {
        if (this.beforeCheckList[i] !== this.constantValue.checklist_tasks[i].check_status) {
          status.push({
            checklist_task_id: this.constantValue.checklist_tasks[i].checklist_task_id,
            check_status: this.constantValue.checklist_tasks[i].check_status
          })
        }
      }
      this.varietyGrowthData.variety_growth.variety_growth_checklist = status

      this.varietyGrowthEdit(data)
    } else {
      this.varietyGrowthData.variety_growth.variety_growth_checklist = []
      // チェックリストに選択状態項目追加
      for (let i in this.constantValue.checklist_tasks) {
        if (this.constantValue.checklist_tasks[i].check_status) {
          this.varietyGrowthData.variety_growth.variety_growth_checklist.push({
            checklist_task_id: this.constantValue.checklist_tasks[i].checklist_task_id
          })
        }
      }

      this.showLoading = false
      this.createData = data
      this.showSaveConfirmModal = true
    }
  }

  private createData: any = {}

  private getVarietyGrowthDetail () {
    (async () => {
      const result = await VarietyGrowthDetailApi.getVarietyGrowthDetail(this.$route.params.variety_growth_id)
      if (result.isOk()) {
        this.varietyGrowthData = result.getPayload()

        let status = []
        // チェックリストに選択状態項目追加
        for (let j in this.varietyGrowthData.variety_growth.variety_growth_checklist) {
          status.push(this.varietyGrowthData.variety_growth.variety_growth_checklist[j].work_check_status)
          for (let i in this.constantValue.checklist_tasks) {
            if (this.varietyGrowthData.variety_growth.variety_growth_checklist[j].checklist_task_id === this.constantValue.checklist_tasks[i].checklist_task_id) {
              this.constantValue.checklist_tasks[i].check_status = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_status
              this.constantValue.checklist_tasks[i].check_update_date = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_update_date
              this.constantValue.checklist_tasks[i].check_updater = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_updater
            }
          }
        }
        // チェックリストに変更があるか確認用に保持
        this.beforeCheckList = status

        this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)

        // 間断潅水flag設定
        for (let i in this.varietyGrowthData.variety_growth_stages) {
          if (this.varietyGrowthData.variety_growth_stages[i].watering_cut_flag === 1) {
            this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private async varietyGrowthCreate () {
    this.showLoading = true
    const result = await VarietyGrowthCreateApi.doVarietyGrowthCreate(this.createData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety-growth').catch(e => {})
    } else {
      this.showSaveConfirmModal = false
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async varietyGrowthEdit (data: any) {
    const result = await VarietyGrowthEditApi.doVarietyGrowthEdit(this.$route.params.variety_growth_id, data)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety-growth').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private countDecimalPoint (val: number) {
    return String(val).split('.')
  }

  private doValidate () {
    this.resetError()
    const varietyNameFlag = Validator.validateInputVarietyName('varietyNameErrorMessage', this.varietyGrowthData.variety_growth.variety_id)
    const varietyGrowthNameFlag = Validator.validateInputVarietyGrowthName('varietyGrowthNameErrorMessage', this.varietyGrowthData.variety_growth.variety_growth_name)
    const harvestCorrectionMinusFlag = Validator.validateInputHarvestCorrectionMinus('harvestCorrectionMinusErrorMessage', this.varietyGrowthData.variety_growth.harvest_correction_minus)
    const harvestCorrectionPlusFlag = Validator.validateInputHarvestCorrectionPlus('harvestCorrectionPlusErrorMessage', this.varietyGrowthData.variety_growth.harvest_correction_plus)
    const areaNameFlag = Validator.validateInputAreaName('areaNameErrorMessage', this.varietyGrowthData.variety_growth.area_id)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true

    // 品種を選択していない場合は目標値のバリデーションを行わない
    if (!varietyNameFlag) {
      return false
    }

    let isValidStage = []

    // 利用するステージの配列を作成
    for (let i in this.varietyGrowthData.variety_growth_stages) {
      if (this.varietyGrowthData.variety_growth_stages[i].is_valid === 1) {
        isValidStage.push(i)
      }
    }

    for (let i in this.varietyGrowthData.variety_growth_stages) {
      const data = this.varietyGrowthData.variety_growth_stages[i]
      // 積算温度バリデーション
      if (data.integrated_temp !== null) {
        if (data.is_valid !== 0) {
          // 前のステージがどれか判定
          let beforeStageKey: any
          for (let j in isValidStage) {
            if (isValidStage[j] === i) {
              beforeStageKey = isValidStage[parseInt(j) - 1]
              if (beforeStageKey === undefined) {
                beforeStageKey = -1
              }
            }
          }

          if (beforeStageKey !== -1 && data.integrated_temp <= this.varietyGrowthData.variety_growth_stages[beforeStageKey].integrated_temp) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は下位ステージより大きくなるように入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else if (data.integrated_temp < 0 || data.integrated_temp > 9000) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は0以上9,000以下の範囲で入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else if (!Number.isInteger(data.integrated_temp)) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は整数で入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else {
            this.$set(this.isError, 'integrated_temp' + i, false)
          }
        }
      } else {
        this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'integrated_temp' + i, true)
      }

      // 値が0~200のバリデーション
      isError = this.rangeValidation(200, data, i, this.masterKeys, isError)
      // 値が0~7000のバリデーション
      isError = this.rangeValidation(7000, data, i, this.elementKeys, isError)

      // 灌水管理名称のバリデーション
      if (data.step === 11 && data.watering_name === '') {
        this.$set(this.errorMessages, 'wateringNameErrorMessage', '収穫適期の灌水管理名称は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'watering_name' + i, true)
      } else {
        this.$set(this.isError, 'watering_name' + i, false)
      }

      // 灌水管理体積含水率のバリデーション
      if (data.water_contain_rate === null) {
        this.$set(this.errorMessages, 'waterContainRateErrorMessage', '体積含水率は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate' + i, true)
      } else if (data.watering_cut_flag === 1 &&
        (data.water_contain_rate < data.water_contain_rate_min || data.water_contain_rate > 100)) {
        this.$set(this.errorMessages, 'waterContainRateErrorMessage', '体積含水率は間断灌水-下限体積含水率の' + data.water_contain_rate_min + '以上100以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate' + i, true)
      } else if (data.water_contain_rate < 0 || data.water_contain_rate > 100) {
        this.$set(this.errorMessages, 'waterContainRateErrorMessage', '体積含水率は0以上100以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate' + i, true)
      } else if (!Number.isInteger(data.water_contain_rate)) {
        this.$set(this.errorMessages, 'waterContainRateErrorMessage', '体積含水率は整数で入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate' + i, true)
      } else {
        this.$set(this.isError, 'water_contain_rate' + i, false)
      }

      // 灌水管理日数のバリデーション
      if (data.watering_days !== null) {
        if (data.watering_days < 0 || data.watering_days > 200) {
          this.$set(this.errorMessages, 'wateringDaysErrorMessage', '日数は0以上200以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'watering_days' + i, true)
        } else if (!Number.isInteger(data.watering_days)) {
          this.$set(this.errorMessages, 'wateringDaysErrorMessage', '日数は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'watering_days' + i, true)
        } else {
          this.$set(this.isError, 'watering_days' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'wateringDaysErrorMessage', '灌水管理日数は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'watering_days' + i, true)
      }

      // 灌水管理下限体積含水率のバリデーション
      if (data.water_contain_rate_min === null) {
        this.$set(this.errorMessages, 'waterContainRateMinErrorMessage', '間断灌水-下限体積含水率は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate_min' + i, true)
      } else if (data.water_contain_rate_min < 0 || data.water_contain_rate_min > 100) {
        this.$set(this.errorMessages, 'waterContainRateMinErrorMessage', '間断灌水-下限体積含水率は0以上100以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate_min' + i, true)
      } else if (!Number.isInteger(data.water_contain_rate_min)) {
        this.$set(this.errorMessages, 'waterContainRateMinErrorMessage', '間断灌水-下限体積含水率は整数で入力してください。')
        isError = false
        this.$set(this.isError, 'water_contain_rate_min' + i, true)
      } else {
        this.$set(this.isError, 'water_contain_rate_min' + i, false)
      }
    }

    return varietyNameFlag && varietyGrowthNameFlag && harvestCorrectionMinusFlag && harvestCorrectionPlusFlag && areaNameFlag && isError
  }

  private rangeValidation (maxValue: number, data: any, i: string, types: any, isError: boolean): boolean {
    for (let j in types) {
      if (data[types[j].keyName] !== null) {
        let decimalPointLength = String(data[types[j].keyName]).split('.')
        if (data[types[j].keyName] < 0 || data[types[j].keyName] > maxValue) {
          this.$set(this.errorMessages, types[j].errorName, types[j].parameta + 'は0以上' + this.toLocaleString(maxValue) + '以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, types[j].keyName + i, true)
        } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
          this.$set(this.errorMessages, types[j].errorName, types[j].parameta + 'は小数点第1位までの範囲で入力してください。')
          isError = false
          this.$set(this.isError, types[j].keyName + i, true)
        } else {
          this.$set(this.isError, types[j].keyName + i, false)
        }
      } else {
        this.$set(this.errorMessages, types[j].errorName, types[j].parameta + 'は必ず入力してください。')
        isError = false
        this.$set(this.isError, types[j].keyName + i, true)
      }
    }
    return isError
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private resetError () {
    // リセット
    this.errorMessages = {}

    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    for (let i in this.varietyGrowthData.variety_growth_stages) {
      // 積算温度バリデーション
      this.$set(this.isError, 'integrated_temp' + i, false)

      // 値が0~200のバリデーション
      for (let j in this.masterKeys) {
        this.$set(this.isError, this.masterKeys[j].keyName + i, false)
        this.masterKeys[j].flag = true
      }

      // 灌水管理名称のバリデーション
      this.$set(this.isError, 'watering_name' + i, false)

      // 灌水管理日数のバリデーション
      this.$set(this.isError, 'watering_days' + i, false)
    }
  }

  private doVarietyGrowthDelete () {
    (async () => {
      this.showLoading = true
      const result = await VarietyGrowthDeleteApi.doVarietyGrowthDelete(this.$route.params.variety_growth_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/variety-growth').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private createCopy () {
    Session.setCopyVarietyGrowthData(JSON.stringify(this.varietyGrowthData))
    this.copyFlag = true
    this.$router.push('/master/variety-growth/create').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/master/variety-growth').catch(e => {})
  }
}
